/** Business terminology for presentation; stored identifiers and judgments stay intact. */
export const REVIEW_AREA_LABELS = {
    pre_site: 'Pre-site form review',
    measurement_applicability: 'Order vs. pre-site review',
    po: 'PO vs. approved estimate',
    acknowledgement: 'Manufacturer acknowledgement',
};
export const COMPARISON_LABELS = {
    po_vs_estimate: REVIEW_AREA_LABELS.po,
    ack_vs_po: 'Acknowledgement vs. PO',
    ack_vs_estimate: 'Acknowledgement vs. approved estimate',
};
export const PRE_SITE_ORDER_STATUS = {
    covered: 'Pre-site review applies to this order',
    fresh_stage1_review_required: 'Pre-site review required',
    assessment_unavailable: 'Pre-site review not found',
    not_applicable: 'Pre-site review not applicable to this order',
};
export function reviewAreaLabel(stage) {
    const area = stage.split(':')[0];
    return (REVIEW_AREA_LABELS[area] ??
        area.replaceAll('_', ' '));
}
export function preSiteOrderAction(reasons = []) {
    if (reasons.includes('assessment_missing'))
        return 'View details';
    if (reasons.includes('configuration_changed'))
        return 'Review order changes';
    if (reasons.includes('measurements_changed'))
        return 'Review form changes';
    if (reasons.includes('freshness_unverified'))
        return 'Verify form revision';
    if (reasons.includes('python_findings_unresolved'))
        return 'Review pre-site findings';
    return 'Review order & pre-site';
}
/**
 * Translate legacy implementation names in analysis and collection prose only.
 * Do not apply to source reports, quoted evidence, specifications, reviewer notes or raw records.
 */
export function reviewNarrative(value) {
    return value
        .replace(/\bstage1_applicability\b/g, 'order vs. pre-site review')
        .replace(/\bPython(?:['’]s)?\s+(?:Stage\s*1\s+)?(?:measurement\s+)?(?:worker|process)\b/gi, 'pre-site review process')
        .replace(/\bPython(?:['’]s)?\s+(?:Stage\s*1\s+)?(?:measurement\s+)?(assessments?|reviews?|results?|findings?|exceptions?|grades?|status)\b/gi, 'pre-site $1')
        .replace(/\bPython['’]s\b/gi, "the pre-site review's")
        .replace(/\bPython\b/g, 'the pre-site review process')
        .replace(/\bStage\s*1\s+(?:measurement\s+)?(?:assessments?|reviews?)\b/gi, (match) => (/s$/i.test(match) ? 'pre-site reviews' : 'pre-site review'))
        .replace(/\bStage\s*1\s+(?:coverage|applicability)\b/gi, 'pre-site review applicability')
        .replace(/\bStage\s*1\b/gi, 'pre-site review')
        .replace(/\bStages?\s*2\s*(?:and|&|–|—|-|\/)\s*3\b/gi, 'purchase order and acknowledgement reviews')
        .replace(/\bStage\s*2\b/gi, 'purchase order review')
        .replace(/\bStage\s*3\b/gi, 'acknowledgement review');
}
